// import React, { useEffect } from 'react';
import css from './style.module.css';

export default function FileDetails({ createdBy, dataAssigned, documentStatus, firstVersion,ReviewedBy }) {
  return (
    <table className="table table-borderless ">
      <tbody className={css.bgTransparent}>
        <tr >
          <td >
            <span className={`fw-semibold ${css.keys}`}>Created by: </span>
            {createdBy || ""}
          </td>
          <td>
            <span className={`fw-semibold ${css.keys}`}>Date Assigned: </span>
            {dataAssigned ? dataAssigned.split("T")[0] : ""}
          </td>
          {firstVersion?.approved_by &&
            (firstVersion.approved_by !== "" || firstVersion.approved_by !== null) && (
              <td>
                <span className={`fw-semibold ${css.keys}`}>Reviewed by: </span>
                {ReviewedBy || ""}
              </td>
            )}
        </tr>
        <tr>
          {firstVersion && firstVersion.documentType && firstVersion.documentType !== "" && (
            <td>
              <span className={`fw-semibold ${css.keys}`}>Document Type: </span>
              {firstVersion.documentType?.length > 0 ? firstVersion.documentType.join(", ") : ""}
            </td>
          )}
          {firstVersion && firstVersion.mediaChannel && firstVersion.mediaChannel !== "" && (
            <td>
              <span className={`fw-semibold ${css.keys}`}>Media Channel: </span>
              {firstVersion.mediaChannel?.length > 0 ? firstVersion.mediaChannel.join(", ") : ""}
            </td>
          )}
          {firstVersion && firstVersion.targetGeography && firstVersion.targetGeography !== "" && (
            <td>
              <span className={`fw-semibold ${css.keys}`}>Target Geography: </span>
              {firstVersion.targetGeography?.length > 0 ? firstVersion.targetGeography.join(", ") : ""}
            </td>
          )}
          {firstVersion && firstVersion.prioritiesLevel && firstVersion.prioritiesLevel !== "" && (
            <td>
              <span className={`fw-semibold ${css.keys}`}>Priority Level: </span>
              {firstVersion.prioritiesLevel}
            </td>
          )}
        </tr>
        {firstVersion && firstVersion.description && firstVersion.description !== "" && (
          <tr>
            <td colSpan="3">
              <span className={`fw-semibold ${css.keys}`}>Description: </span>
              {firstVersion.description}
            </td>
          </tr>
        )}
      </tbody>
    </table>


  );
}
